// Grid/list view functions
const ViewSwitcher = {
  gridViewBtn: null,
  listViewBtn: null,
  productGrid: null,
  currentView: "grid",
  pageIdentifier: "",
  config: null,

  init(config) {
    this.config = config || {};
    this.gridViewBtn = document.getElementById("grid-view");
    this.listViewBtn = document.getElementById("list-view");
    // this.productGrid = document.getElementById("product-grid");

    // Determine the page type using data-template attribute
    const bodyElement = document.body;
    const pageType = bodyElement.getAttribute('data-template');

     // Select the appropriate container based on page type
    if (pageType === 'search') {
      this.productGrid = document.getElementById("product-grid-ul");
    } else {
      this.productGrid = document.getElementById("product-grid");
    }

    if (!this.gridViewBtn || !this.listViewBtn || !this.productGrid) {
      console.error("Required elements not found");
      return;
    }

    this.pageIdentifier = this.getPageIdentifier();
    this.loadSavedView();
    this.setupEventListeners();
    this.applyCurrentView(false); // No animation on initial load
  },

  getPageIdentifier() {
    if (this.config.pageType === "collection") {
      return this.getCollectionIdFromUrl();
    } else if (this.config.pageType === "search") {
      return "search";
    } else if (this.config.identifierElementId) {
      const element = document.getElementById(this.config.identifierElementId);
      return element ? element.value || element.textContent : "";
    }
    return "";
  },

  getCollectionIdFromUrl() {
    const path = window.location.pathname;
    const collectionsIndex = path.indexOf("/collections/");
    if (collectionsIndex === -1) return "";

    const collectionPath = path.slice(
      collectionsIndex + "/collections/".length
    );
    return collectionPath.split("/")[0].split("?")[0];
  },

  setupEventListeners() {
    this.gridViewBtn.addEventListener("click", (event) => {
      event.preventDefault();
      this.switchView("grid");
    });

    this.listViewBtn.addEventListener("click", (event) => {
      event.preventDefault();
      this.switchView("list");
    });
  },

  switchView(view) {
    if (this.currentView !== view) {
      this.currentView = view;
      this.applyCurrentView(true);
      this.saveCurrentView();
    }
  },

  applyCurrentView(animate = true) {
    if (animate) {
      this.productGrid.style.opacity = "0";
      this.productGrid.style.transition = "opacity 0.2s ease-out";
    }

    setTimeout(
      () => {
        if (this.currentView === "grid") {
          this.productGrid.classList.remove("list_product");
          document.querySelector('body').classList.remove("list_product_desktop");
          this.productGrid.classList.add("grid_product");
          this.productGrid.classList.add("grid");
          this.setActiveButton(this.gridViewBtn);
        } else {
          document.querySelector('body').classList.add("list_product_desktop");
          this.productGrid.classList.remove("grid_product");
          this.productGrid.classList.remove("grid");
          this.productGrid.classList.add("list_product");
          this.setActiveButton(this.listViewBtn);
        }

        if (animate) {
          this.productGrid.style.opacity = "1";
          setTimeout(() => {
            this.productGrid.style.transition = "";
          }, 300);
        }
      },
      animate ? 300 : 0
    );
  },

  setActiveButton(activeButton) {
    this.gridViewBtn.classList.remove("active");
    this.listViewBtn.classList.remove("active");
    activeButton.classList.add("active");
  },

  saveCurrentView() {
    localStorage.setItem(
      `viewPreference_${this.pageIdentifier}`,
      this.currentView
    );
  },

  loadSavedView() {
    const savedView = localStorage.getItem(
      `viewPreference_${this.pageIdentifier}`
    );
    if (savedView) {
      this.currentView = savedView;
    }
  },
};

const QuoteProxyManager = {
  init() {
    this.setupEventListeners();
  },

  setupEventListeners() {
    document.body.addEventListener(
      "click",
      this.handleQuoteProxyClick.bind(this)
    );
  },

  handleQuoteProxyClick(event) {
    if (!event.target.matches(".quote_proxy_btn")) return;

    event.preventDefault();

    const rfqCollectionBtn = this.findRfqCollectionButton(event.target);
    if (rfqCollectionBtn) {
      rfqCollectionBtn.click();
    } else {
      console.error("RFQ collection button not found");
    }
  },

  findRfqCollectionButton(element) {
    let current = element;
    for (let i = 0; i < 4; i++) {
      current = current.parentElement;
      if (!current) return null;
    }
    return current.querySelector(".rfq-collection-btn");
  },
};

const FacetSearchManager = {
  init() {
    this.facetSearchInput = document.getElementById("facet-search-input");
    this.searchInModalCustom = document.getElementById("Search-In-Modal");
    this.searchButton = document.querySelector(".search__button");

    if (this.facetSearchInput) {
      this.setupEventListeners();
    } else {
      console.error("Facet search input not found");
    }
  },

  setupEventListeners() {
    this.facetSearchInput.addEventListener(
      "keydown",
      this.handleKeyDown.bind(this)
    );
    this.facetSearchInput.addEventListener(
      "input",
      this.handleInput.bind(this)
    );
  },

  handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.triggerSearch();
    }
  },

  handleInput(event) {
    if (this.searchInModalCustom) {
      this.searchInModalCustom.value = event.target.value;
    } else {
      console.error("Search in modal custom input not found");
    }
  },

  triggerSearch() {
    if (this.searchButton) {
      this.searchButton.click();
    } else {
      console.error("Search button not found");
    }
  },
};

const ajaxinateInit = {
  endlessCollection: null,

  init() {
    this.destroyExistingInstance();
    this.createNewInstance();
  },

  destroyExistingInstance() {
    if (
      this.endlessCollection &&
      typeof this.endlessCollection.destroy === "function"
    ) {
      this.endlessCollection.destroy();
      this.endlessCollection = null;
    }
  },

  createNewInstance() {
    try {
      var productGridSelector = "#product-grid";
       if (window.location.pathname.includes('/search')) {
          productGridSelector = "#product-grid-ul";
       }
      this.endlessCollection = new Ajaxinate({
        container: productGridSelector,
        pagination: ".infinite_next",
      });
    } catch (error) {
      console.error("Failed to initialize Ajaxinate:", error);
    }
  },
};

const allfunctionsInit = {
  init() {
    // For collection pages
    ViewSwitcher.init({ pageType: "collection" });

    // For search pages
    // ViewSwitcher.init({ pageType: 'search' });

    // Initialize the QuoteProxyManager
    QuoteProxyManager.init();

    // Initialize the FacetSearchManager
    // FacetSearchManager.init();

    // Initialize Ajaxinate
    ajaxinateInit.init();
    console.log("Errwerewrewrwerwr")
  },
};

// Initilaze the swiper on sub collections
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".col_banner_images")) {
    window.custom.initializeGlobalSwiper(".col_banner_images", {
      slidesPerView: 2.8,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
      },
    });
  }

  allfunctionsInit.init();
});
